import React from 'react'
import './cover.css'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];

const Nophotocover = ({onScrollClick,details,showScrollIndicator,hideScrollIndicator}) => {
     const isLargeNameFont = LARGE_NAME_FONTS.includes(
  details?.nameFontStyle
); 
  
  const groomNameBanner=()=>{
    return(<h3 
    className={`t3-cover-name ${
        isLargeNameFont ? "t3-cover-name--compact" : ""
      }`}
    style={{fontFamily:details.nameFontStyle}}>{ details?.groomName} </h3>)
  }

  const brideNameBanner=()=>{
     return(<h3 
      className={`t3-cover-name ${
        isLargeNameFont ? "t3-cover-name--compact" : ""
      }`}
     style={{fontFamily:details.nameFontStyle}}>{ details?.brideName} </h3>)
  }
  return (
   <section className='cover no-photo-cover theme-3-cover cover-animate'>

<div className="t3-cover-decoration">

  {/* Top arch */}
  <img
    src="/theme3-vover-page-frame.png"
    className="t3-cover-top-frame"
    alt=""
  />

  {/* Left pillar */}
  <img
    src="/theme3-cover-page-asset.png"
    className="t3-cover-pillar t3-cover-pillar-left"
    alt=""
  />

  {/* Right pillar */}
  <img
    src="/theme3-cover-page-asset.png"
    className="t3-cover-pillar t3-cover-pillar-right"
    alt=""
  />

</div>
   <div className="t3-cover-details">
      {/* <span className="t3-no-photo-cover-content">
          We are honoured to welcome you to the wedding ceremony of
        </span> */}

          <span className="t3-no-photo-cover-content">
  We are honored to welcome you to the {details?.functionType || "wedding"} ceremony of
</span>
        <div className="t3-cover-name-wrapper">
                 {details?.displayOrder==="groomFirst"?<>
               {groomNameBanner()}
              <span 
               className={`t3-cover-and ${
        isLargeNameFont ? "t3-cover-and--compact" : ""
      }`}
              
              style={{fontFamily:details.nameFontStyle}}>&</span>
              {brideNameBanner()}
         </>:<>
                {brideNameBanner()}
              <span 
                   className={`t3-cover-and ${
        isLargeNameFont ? "t3-cover-and--compact" : ""
      }`}
              
               style={{fontFamily:details.nameFontStyle}}>&</span>
                 {groomNameBanner()} 
         </>}
        </div>
          {details?.hashtag && (
    <div className="t3-cover-hashtag">#{details.hashtag}</div>
)}
   </div>
     {showScrollIndicator && (<div  className={`t3-scroll-indicator ${ hideScrollIndicator ? "hide" : ""}`} onClick={onScrollClick}>
                      <ExpandMoreIcon className='t3-scroll-indication-icon' />
                    <span>SCROLL</span>
                  </div>) }
   </section>
  )
}

export default Nophotocover